import { useCallback, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePinTrigger } from '../hooks/usePinTrigger';
import OTPModal from './modals/OTPModal';
import { closeApp } from '../utils/closeApp';
import { clearContribution } from '../utils/contribution';
import { clearTicket } from '../utils/ticket';

const PIN_EXCLUDE_SELECTORS = ['button', 'input', 'select', 'textarea', 'a'];

function GlobalPinHandler() {
  const [showPinModal, setShowPinModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const pathRef = useRef(location.pathname);
  pathRef.current = location.pathname;

  const handlePinTrigger = useCallback(() => {
    setShowPinModal(true);
  }, []);

  usePinTrigger({
    onTrigger: handlePinTrigger,
    excludeSelectors: PIN_EXCLUDE_SELECTORS,
    clickDelay: 500,
  });

  const resetKiosk = () => {
    clearTicket();
    clearContribution();
  };

  const handlePinSuccess = () => {
    setShowPinModal(false);
    const path = String(pathRef.current || '/').replace(/\/+$/, '') || '/';
    if (path === '/') {
      closeApp();
      return;
    }
    resetKiosk();
    navigate('/', { replace: true });
  };

  return (
    <OTPModal
      show={showPinModal}
      onHide={() => setShowPinModal(false)}
      onSuccess={handlePinSuccess}
    />
  );
}

export default GlobalPinHandler;
